import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { map, startWith } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {
    private readonly translate = inject(TranslateService);

    public readonly currentLanguage = toSignal(
        this.translate.onLangChange.pipe(
            map(event => event.lang),
            startWith(this.translate.currentLang)
        ),
        { initialValue: this.translate.currentLang }
    );
}
